export default __webpack_public_path__ + "static/media/boon.aaa28186.png";